module.exports = __webpack_public_path__ + "static/media/from-window.05c83027.jpg";